import { Clock, Radio, CheckCircle, Link, CheckSquare, Square } from 'lucide-react'

const eventIcons = {
  upcoming: <Clock size={11} />,
  live: <Radio size={11} />,
  completed: <CheckCircle size={11} />,
}

export default function YTCardList({ videos, loading, selected, onSelect, channels, checked, onToggle, onToggleAll }) {
  const channelMap = {}
  for (const ch of channels) channelMap[ch.youtube_channel_id] = ch.name

  const allChecked = videos.length > 0 && videos.every(v => checked.has(v.youtube_id))

  function formatDate(dateStr) {
    if (!dateStr) return ''
    const d = new Date(dateStr)
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  }

  function formatDuration(mins) {
    if (!mins) return ''
    const h = Math.floor(mins / 60)
    const m = mins % 60
    return h > 0 ? `${h}h ${m}m` : `${m}m`
  }

  if (loading && videos.length === 0) {
    return <div className="yt-card-list-empty">Loading...</div>
  }

  if (videos.length === 0) {
    return <div className="yt-card-list-empty">No videos found</div>
  }

  return (
    <div className="yt-card-list">
      <div className="yt-card-list-header">
        <label className="select-all" onClick={onToggleAll}>
          {allChecked ? <CheckSquare size={16} /> : <Square size={16} />}
          <span>Select all</span>
        </label>
      </div>

      <div className="yt-card-list-items">
        {videos.map(v => {
          const isSelected = selected?.youtube_id === v.youtube_id
          const isChecked = checked.has(v.youtube_id)

          return (
            <div
              key={v.youtube_id}
              className={`yt-card-item ${isSelected ? 'selected' : ''} ${isChecked ? 'checked' : ''}`}
            >
              <div className="yt-card-checkbox" onClick={e => { e.stopPropagation(); onToggle(v.youtube_id) }}>
                {isChecked ? <CheckSquare size={16} /> : <Square size={16} />}
              </div>

              <div className="yt-card-content" onClick={() => onSelect(v)}>
                <div className="yt-card-thumb">
                  {(v.thumbnail_override_url || v.thumbnail_url) ? (
                    <img src={v.thumbnail_override_url || v.thumbnail_url} alt="" className={v.thumbnail_override_url ? 'yt-thumb-overridden' : ''} />
                  ) : (
                    <div className="yt-card-thumb-placeholder" />
                  )}
                </div>

                <div className="yt-card-info">
                  <div className="yt-card-title">{v.title || 'Untitled'}</div>
                  <div className="yt-card-meta">
                    <span className={`yt-event-badge ${v.event_type}`}>
                      {eventIcons[v.event_type]} {v.event_type}
                    </span>
                    {v.scheduled_start ? (
                      <span className="yt-card-date">{formatDate(v.scheduled_start)}</span>
                    ) : v.published_at ? (
                      // dev24: VOD fallback to YouTube upload date
                      <span className="yt-card-date" title="YouTube upload date" style={{ fontStyle: 'italic', opacity: 0.85 }}>
                        {formatDate(v.published_at)}
                      </span>
                    ) : null}
                    {v.duration_minutes > 0 && (
                      <span className="yt-card-duration">{formatDuration(v.duration_minutes)}</span>
                    )}
                  </div>
                  <div className="yt-card-sub">
                    <span className="yt-card-channel">{channelMap[v.youtube_channel_id] || '—'}</span>
                    {v.tbtv_id && <span className="yt-card-linked"><Link size={10} /> Linked</span>}
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
